/** @jsxImportSource @emotion/core */
import { css } from '@emotion/core';
import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { ResponsiveWrapper, Wrapper } from 'components/styled/Wrapper';
import { NavButton } from 'components/styled/Button';
import Text from 'components/styled/Text';
import { Box, Flex } from 'components/styled';

import { useUserToken } from 'auth';

import fileSearchingImage from 'assets/file-searching.gif';

import { isAuthPath } from 'auth/routes';

import { usePageTitle } from 'hooks/seoHooks';

const NotFound: React.FC<RouteComponentProps> = ({
	location: { pathname },
	history: { goBack, push },
}) => {
	// Page title
	usePageTitle('Stránka nenalezena');

	const token = useUserToken();
	useEffect(() => {
		if (!token && isAuthPath(pathname)) {
			push({ pathname: '/login', state: { redirect: pathname } });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Wrapper bg="white" position="relative">
			<ResponsiveWrapper alignItems="flex-start" bg="transparent">
				<Box zIndex={1}>
					<Text
						color="text"
						fontSize="xl"
						fontWeight="bold"
						mt={5}
						mb={4}
						as="h2"
					>
						Stránka nenalezena (404)
					</Text>
					<Text>
						Stránka{' '}
						<Text as="span" fontWeight="bold">
							{pathname}
						</Text>{' '}
						nebyla nenalezena.
					</Text>

					<NavButton mt={3} onClick={goBack}>
						Zpět
					</NavButton>
				</Box>
				<Flex
					opacity={0.8}
					zIndex={0}
					width={1}
					justifyContent="center"
					css={css`
						translate: 0 -100px;
					`}
				>
					<Flex width="50%" height="50%" minWidth="375px" minHeight="375px">
						<img width="100%" height="100%" src={fileSearchingImage} />
					</Flex>
				</Flex>
			</ResponsiveWrapper>
		</Wrapper>
	);
};

export default NotFound;
